import { useState } from 'react';

export function useFileHubDrive() {
  const [selectedDriveFileId, setSelectedDriveFileId] = useState('');
  const [triagedDriveFileIds, setTriagedDriveFileIds] = useState(() => new Set());
  const [driveFolderId, setDriveFolderId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [driveFiles, setDriveFiles] = useState([]);

  return {
    selectedDriveFileId, setSelectedDriveFileId,
    triagedDriveFileIds, setTriagedDriveFileIds,
    driveFolderId, setDriveFolderId,
    isLoading, setIsLoading,
    driveFiles, setDriveFiles,
  };
}
